<template>
    <div class="form-group" :id="fieldName + '-select-field'" :class="{ 'has-error': form.errors.has(this.fieldConfig.value_field) }">
        <label class="form-control-label" v-if="showLabel">
            <span v-html="fieldConfig.label"></span>
            <span class="required" v-if="fieldConfig.field_extra.required">&nbsp;&nbsp;(*)</span>
            <span v-if="withHelpIcon" :class="fieldConfig.field_extra.withIcon" :title="fieldConfig.field_extra.helpText"></span>
        </label>

        <multi-select
            :value="optionValue"
            :options="fieldConfig.options"
            :track-by="fieldConfig.optionValueField"
            :label="fieldConfig.optionLabelField"
            :placeholder="fieldConfig.label"
            @input="updateValue"
            class="form-control"
            :disabled="fieldConfig.disabled === 1 || fieldConfig.disabled === true"
            :show-labels="showMultiselectLabels"
            :select-label="selectLabel"
            :deselect-label="deselectLabel"
            :allow-empty="allowEmpty"
        ></multi-select>
        <span class="help-block" v-if="form.errors.has(this.fieldConfig.value_field)">
            {{ form.errors.get(this.fieldConfig.value_field, true) }}
        </span>
        <div v-if="hasHelpText">
            <span v-html="fieldConfig.field_extra.helpText"></span>
        </div>

        <modal
            v-if="showModal"
            class="modal"
            modalWidth="50%"
            @close="showModal = false"
        >
            <span slot="header" v-html="fieldConfig.label"></span>
            <div slot="body">
                <span v-html="fieldConfig.field_extra.modalText"></span>
                <div v-if="fieldConfig.field_extra.modalIsConfirm" class="center-text action-buttons">
                    <button class="specialwidgetsubmitbutton inputbutton1 mr-2 mt-2" @click="optionIsConfirmed">{{ fieldConfig.field_extra.confirmText }}</button>
                    <button class="specialwidgetsubmitbutton inputbutton1 mt-2" @click="optionIsCancelled">{{ fieldConfig.field_extra.cancelText }}</button>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import MultiSelect from "vue-multiselect";
import { FormFieldMixin, HasOptionsMixin } from 'laravel-vue-forms';
import {isArray} from "lodash";

export default {
    mixins: [
            FormFieldMixin,
            HasOptionsMixin
        ],

    components: {
        MultiSelect
    },

    props: {
        showMultiselectLabels: {
            type: Boolean,
            default: true
        },
        allowEmpty: {
            type: Boolean,
            default: true
        },
        selectLabel: {
            type: String,
            default: "Press enter to select"
        },
        deselectLabel: {
            type: String,
            default: "Press enter to remove"
        }
    },

    data() {
        return {
            showModal: false,
            confirmingValue: null
        }
    },

    methods: {
        updateValue(value) {
            this.form.errors.clear(this.fieldConfig.value_field);
            if(this.checkIfConfirmationNeeded(value)) {
                this.showModal = true;
                this.confirmingValue = value;
            } else if(value) {
                this.$emit("input", value[this.fieldConfig.optionValueField]);
            } else {
                this.$emit("input", null);
            }
        },
        checkIfConfirmationNeeded(value) {
            if (!value) {
                return false;
            }

            if (isArray(this.fieldConfig.field_extra.showModalOnValue)
                && this.fieldConfig.field_extra.showModalOnValue.includes(value[this.fieldConfig.optionLabelField])) {
                return true;
            }

            return this.fieldConfig.field_extra.showModalOnValue === value[this.fieldConfig.optionLabelField];
        },
        optionIsConfirmed() {
            this.$emit("input", this.confirmingValue[this.fieldConfig.optionValueField]);
            this.showModal = false;
        },
        optionIsCancelled() {
            const defaultOption = this.fieldConfig.options.find(option => {
                return option[this.fieldConfig.optionLabelField] === this.fieldConfig.default
            })

            if(defaultOption) {
                this.$emit("input", defaultOption[this.fieldConfig.optionValueField]);
            }

            this.showModal = false
        }
    }
};
</script>
